import React from 'react';

const TastingRoomStartPage = React.lazy(() => import('pages/tasting-room/start'));
const TastingRoomCheckout = React.lazy(() => import('pages/tasting-room/checkout'));
const NewOrderPage = React.lazy(() => import('pages/orders/new-order'));

const policies = [{ resource: 'orders', action: 'createNewOrder' }];

export const publicDefinitions = [
  {
    path: 'checkout/:ocsFunnel/:checkoutNanoID',
    component: <TastingRoomCheckout />
  }
];

export const privateDefinitions = [
  {
    path: 'start',
    policies: policies,
    component: <TastingRoomStartPage />
  },
  {
    path: 'new-order',
    policies: policies,
    component: <NewOrderPage />
  }
];
